import {computed, Injectable, signal, WritableSignal} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {
    CargoItem,
    defaultSaldoCta,
    HistorialMovimientosInterface,
    NoResultadosInterface,
    SaldoCta
} from '../../interfaces/pagos.interface';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment.development';
import {LoginServices} from "../../../auth/login/services/login.service";
import {isNumeric} from "../../../shared/services/utils-service";

let apiVucUrl = environment.apiVucUrl

@Injectable({
    providedIn: 'root'
})
export class TramitePagosService {
    cuenta: WritableSignal<SaldoCta | null> = signal(defaultSaldoCta);
    hasBalance = computed(() => {
        if (!this.cuenta())
            return false;
        return this.parsearSaldo(this.cuenta()!)
    })

    constructor(private http: HttpClient, private loginServices: LoginServices) {
    }

    /**
     * Procesa el pago en Cta. Individual del cliente.
     */
    pagoCta(pagos: CargoItem) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + this.loginServices.session()?.token
        })
        return this.http.post<CargoItem>(apiVucUrl + `api/v1.0/cta/cargo`, pagos, {
            headers: headers,
            observe: 'response'
        })
    }

    consultarSaldo() {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + this.loginServices.session()?.token
        })
        let uniqueId = this.loginServices.session()?.perfil.uniqueId;
        if (uniqueId == null || undefined) {
            this.cuenta.set(defaultSaldoCta);
            return null;
        }
        return this.http.get<SaldoCta>(apiVucUrl + `api/v1.0/cta/${uniqueId}`, {
            headers: headers,
            observe: 'response'
        }).subscribe({
            next: (result) => {
                if (this.isSaldoCtaType(result.body)) {
                    this.cuenta.set(result.body!);
                } else {
                    this.cuenta.set(defaultSaldoCta)
                }
            },
            error: (error) => {
                this.cuenta.set(defaultSaldoCta)
                console.log(`error -> ${error}`)
            }
        });
    }

    consultarMovimientos(fechaInicio: string, fechaFin: string, codigoBanco: string | null, numeroDocumento: string | null | undefined): Observable<HistorialMovimientosInterface[] | NoResultadosInterface> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ` + this.loginServices.session()?.token
        })
        return this.http.get<NoResultadosInterface | HistorialMovimientosInterface[]>(apiVucUrl + `api/v1.0/cta/movimientos?codigoBanco=${codigoBanco}&desde=${fechaInicio}&hasta=${fechaFin}&numeroDocumento=${numeroDocumento}`, {headers: headers})
    }

    private parsearSaldo(cta: SaldoCta | null): boolean {
        if (!cta) {
            return false;
        }
        const parsedSaldo = cta.saldo;
        if (isNaN(parsedSaldo) || !isNumeric(parsedSaldo)) {
            return false;
        }
        return parsedSaldo > 0;
    }

    private isSaldoCtaType(obj: any): obj is SaldoCta {
        return typeof obj.saldo === 'number';
    }

    resetState() {
        this.cuenta.set(null)
    }
}
